import { render, staticRenderFns } from "./lor-facets.vue?vue&type=template&id=3d90f3a6&scoped=true&"
import script from "./lor-facets.ts?vue&type=script&lang=ts&"
export * from "./lor-facets.ts?vue&type=script&lang=ts&"
import style0 from "./lor-facets.scss?vue&type=style&index=0&id=3d90f3a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d90f3a6",
  null
  
)

export default component.exports